import { useEffect, useRef } from "react";

// Subtle gold cursor: small dot + trailing ring. Grows over interactive elements.
export default function Cursor() {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (isTouch) return;

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let ringX = mouseX, ringY = mouseY;
    let dotX = mouseX, dotY = mouseY;
    let raf;

    const move = (e) => { mouseX = e.clientX; mouseY = e.clientY; };
    const onEnter = () => ring.current?.classList.add("is-hover");
    const onLeave = () => ring.current?.classList.remove("is-hover");

    const loop = () => {
      dotX += (mouseX - dotX) * 0.6;
      dotY += (mouseY - dotY) * 0.6;
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
      if (dot.current) dot.current.style.transform = `translate(${dotX}px, ${dotY}px) translate(-50%, -50%)`;
      if (ring.current) ring.current.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", move);
    const nodes = document.querySelectorAll("a, button, [role='button'], input, textarea, [data-cursor='hover']");
    nodes.forEach((n) => { n.addEventListener("mouseenter", onEnter); n.addEventListener("mouseleave", onLeave); });
    raf = requestAnimationFrame(loop);

    // observe DOM changes to re-bind
    const obs = new MutationObserver(() => {
      const fresh = document.querySelectorAll("a, button, [role='button'], input, textarea, [data-cursor='hover']");
      fresh.forEach((n) => {
        n.removeEventListener("mouseenter", onEnter);
        n.removeEventListener("mouseleave", onLeave);
        n.addEventListener("mouseenter", onEnter);
        n.addEventListener("mouseleave", onLeave);
      });
    });
    obs.observe(document.body, { subtree: true, childList: true });

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", move);
      obs.disconnect();
    };
  }, []);

  return (
    <>
      <div ref={ring} className="he-cursor-ring" aria-hidden="true" />
      <div ref={dot} className="he-cursor-dot" aria-hidden="true" />
    </>
  );
}
